import alt from 'components/Dispatcher';

class EnvActions {
  constructor() {
    this.generateActions('getEnv', 'envLoading', 'envError', 'envSuccess');
  }
}

export default alt.createActions(EnvActions);
